import React, { useCallback } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Hint } from "@progress/kendo-react-labels";
import { capitalizeFirstLetter } from "../../../../../../utils/common";
import { EXPRESSION_LABELS } from "../../../constants/expressionBuilder.constants";
import "../../../styles/ExpressionBuilder.css";
import { getOperatorsByType } from "../../../utils/expressionBuilder.utils";

/**
 * Component for operator selection in expression rules
 * @param {string} fieldType - Type of the selected field
 * @param {string} selectedOperator - Currently selected operator
 * @param {Function} onOperatorChange - Operator change handler
 * @param {boolean} showHint - Whether to show available operators hint
 * @returns {JSX.Element} Operator selection component
 * @author Abhishek Dhillon
 * @parent RuleComponent
 */
const OperatorSelection = ({ fieldType, selectedOperator, onOperatorChange, showHint = true }) => {
  const operators = getOperatorsByType(fieldType).map((op) => ({ ...op, group: capitalizeFirstLetter(op.type) }));

  /**
   * Handles operator selection change
   * @param {Object} e - Event object
   * @author Abhishek Dhillon
   */
  const handleOperatorChange = useCallback(
    (e) => {
      onOperatorChange(e.target.value);
    },
    [onOperatorChange]
  );

  /**
   * Gets available operators hint text
   * @returns {string} Hint text for available operators
   * @author Abhishek Dhillon
   */
  const getOperatorHint = () => {
    return ``;
  };

  return (
    <div className='expression-builder-rule-operator'>
      <label>{EXPRESSION_LABELS.OPERATOR}</label>
      <DropDownList
        data={operators}
        textField='label'
        groupField='group'
        valueField='id'
        value={selectedOperator || ""}
        onChange={handleOperatorChange}
        placeholder={EXPRESSION_LABELS.SELECT_OPERATOR}
        className='expression-builder-w-100'
        id='operator-selection-dropdown'
        fillMode={"solid"}
        required={true}
      />
      {showHint && operators.length > 0 && <Hint>{getOperatorHint()}</Hint>}
    </div>
  );
};

export default OperatorSelection;
